import { useEffect } from "react";
import { setLayoutDashboardTitle } from "../../../../store/ui-slice";
import useIsMobile from "../../../../hooks/useIsMobile";


const useEditorTitle = ({ dispatch, currentUrl, isBerangkat, headerData }) => {
  const isMobile = useIsMobile();
  useEffect(() => {
    const isNew = currentUrl.includes("new");

    if (isMobile) {
      dispatch(
        setLayoutDashboardTitle({
          title: `${isNew ? "New - " : ""}${
            isBerangkat ? "Berangkat" : "Kembali"
          } - ${
            headerData.data_kendaraan
              ? headerData.data_kendaraan.nomor_polisi
              : ""
          }`,
        })
      );
    } else {
      dispatch(
        setLayoutDashboardTitle({
          title: `${isNew ? "New - " : ""}${
            isBerangkat ? "Berangkat" : "Kembali"
          } - ${
            headerData.data_kendaraan
              ? headerData.data_kendaraan.nomor_polisi +
                " | " +
                headerData.data_kendaraan.merek
              : ""
          }`,
        })
      );
    }
  }, [currentUrl, headerData, headerData.kendaraan]);
};

export default useEditorTitle;
